// extracted by mini-css-extract-plugin
export var container = "title-module--container--bAdiF";
export var title = "title-module--title--3ea8n";
export var subtitle = "title-module--subtitle--1pygZ";